<template>
  <div class="quiz__users">
    <img :src="mediaBaseUrl + 'quiz/users/rewards.png'" alt="rewards">

    <div class="img">
      <img :src="`${mediaBaseUrl}quiz/covers/${gender}/users.png`" alt="" @load="$emit('imageLoaded')">
    </div>

    <header>
      <h2>1,008,326 {{$t('quiz.list[4].people')}}</h2>
      <p>{{$t('quiz.list[4].joined')}}</p>
    </header>
  </div>
</template>

<script>
export default {
  name: "quiz-users",
  inject: ["mediaBaseUrl"],
  props: ["gender"],
}
</script>
